import React from "react";

export function useInterval(callback, intervalTiming, delay = 0) {
  const savedCallback = React.useRef();
  const [hasDone, setHasDone] = React.useState(false);
  React.useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  React.useEffect(() => {
    function tick() {
      savedCallback?.current?.();
    }

    if (delay && !hasDone) {
      let id = setTimeout(() => {
        setHasDone(true);
        tick();
      }, delay);
      return () => clearTimeout(id);
    }
    if (intervalTiming !== null) {
      let id = setInterval(tick, intervalTiming);
      return () => clearInterval(id);
    }
  }, [intervalTiming, hasDone]);
}
